/* unplugin-vue-components disabled */import script from "./Statistic.vue?vue&type=script&setup=true&lang=js"
export * from "./Statistic.vue?vue&type=script&setup=true&lang=js"

import "./Statistic.vue?vue&type=style&index=0&id=18b48958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b48958"]])

export default __exports__